import { h } from 'preact';
import * as actions from 'store/actions';
import Store from 'store/store';
import { accessNested } from 'utils/utils';

let staticRender;
let storeListeners = {};

const firePageLoad = () => {
	const store = Store.get();
	const dataLayerVariables = accessNested(store, 'appData.meta.dataLayer', {});
	const movieName = accessNested(store, 'appData.meta.title.locale') || accessNested(store, 'appData.meta.title.en');
	const region = accessNested(store, 'appData.meta.region.slug');
	const activePage = accessNested(store, 'activePage.id');
	const genre = dataLayerVariables.genre || accessNested(store, 'appData.meta.genre', '-');
	const imdb_id = dataLayerVariables.imdb_id || accessNested(store, 'appData.meta.movieIMDBID', '-');
	const releaseDate = accessNested(store, 'appData.meta.dates.release');
	let {
		essence_genre = '-',
		genre_1 = '-',
		fs_o,
		content_genome = '-',
	} = dataLayerVariables;

	if (!fs_o || fs_o === '') {
		fs_o = undefined;
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'Landing',
		site: {
			name: `${movieName} Movie - Showtimes Site`,
			market: region,
			template: 'Powster'
		},
		page: {
			name: activePage,
			type: 'Showtimes'
		},
		movie: {
			name: movieName,
			release_date: releaseDate,
			imdb_id,
			genre: {
				essence_genre,
				genre_1: genre_1 || genre || '-',
				fs_o,
				content_genome
			}
		}
	});
};

const fireWatchNow = (vendorName) => {
	const movieName = accessNested(Store.get(), 'appData.meta.title.locale') || accessNested(Store.get(), 'appData.meta.title.en');

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'RetailerClick',
		movieName: movieName,
		merchant: vendorName
	});
};

const fireBuyTickets = (theater, screening) => {
	const movieName = accessNested(Store.get(), 'appData.meta.title.locale') || accessNested(Store.get(), 'appData.meta.title.en');
	const exhibitor = theater.exhibitor || {};
	const exhibitorName = exhibitor.name || exhibitor.domain;
	const theaterLocation = theater.location || {};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'TicketClick',
		city: theaterLocation.city,
		format: screening.movie.format.name,
		date: screening.date,
		day: screening.stDate.dayShort,
		time: screening.time24,
		theaterName: exhibitorName
	});
};

const fireShare = (id) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'SocialLinkShare',
		eventAction: id
	});
};

const fireSignUpSubmit = (list) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'gaEvent',
		eventCategory: 'Mailing List Subscribed',
		eventAction: list
	});
};

const fireDownloadImage = (index) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'Download',
		type: 'image',
		label: `Gallery Image ${index}`
	});
};

const fireCalendarReminderClick = (cal) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'SetReminder',
		type: cal
	});
};

const fireVideoPlay = (video, platform) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'VideoPlay',
		platform,
		video
	});
};

const fireHomeCTAButtonClick = (label) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'CTAButtonClick',
		buttonLabel: label,
	});
};

storeListeners[actions.PAGE_STATE_LOADED] = () => {
	firePageLoad();
	setTimeout(() => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: '3secDwell',
		});
	}, 3000);
};

storeListeners[actions.SET_ACTIVE_PAGE] = () => {
	firePageLoad();
};

storeListeners[actions.HOMEENT_VENDOR_CLICKED] = (url, name, altCategory, pageId) => {
	let vendorName;
	const useTrackingPrefixForGA = accessNested(Store.get(), 'activePage.data.useTrackingPrefixForGA');
	if (url) {
		url = new URL(url);
		vendorName = url.hostname.replace('www.', '').replace('.com', '');
	} else if (pageId) {
		vendorName = '/' + pageId.toLowerCase();
	}

	if (url && useTrackingPrefixForGA) {
		vendorName = name; // 09-24-20: When url domain names are all the same, but vendor names are unique
	}

	fireWatchNow(vendorName);
};

storeListeners[actions.TICKET_LINK_CLICKED] = (screening, theater, ev, provider = 'cinema') => {
	fireBuyTickets(theater, screening);
};

storeListeners[actions.CLICKED_SHARE] = (id) => {
	fireShare(id);
};

storeListeners[actions.SIGN_UP_SUBMIT] = (list) => {
	fireSignUpSubmit(list);
};

storeListeners[actions.GALLERY_DOWNLOAD_IMAGE] = (index) => {
	fireDownloadImage(index);
};

storeListeners[actions.CALENDAR_CLICKED] = ({ title }) => {
	fireCalendarReminderClick(title);
};

storeListeners[actions.YOUTUBE_PROGRESS] = (step, ytid) => {
	if (step === 0) {
		fireVideoPlay(ytid, 'Youtube');
	}
};

storeListeners[actions.JW_PLAYER_PROGRESS] = (step, name) => {
	if (step === 0) {
		fireVideoPlay(name, 'JWPlayer');
	}
};

storeListeners[actions.VIMEO_VIDEO_PROGRESS] = (step, name) => {
	if (step === 0) {
		fireVideoPlay(name, 'Vimeo');
	}
};

storeListeners[actions.HOME_BUTTON_CLICKED] = (label) => {
	fireHomeCTAButtonClick(label);
};

export {
	staticRender,
	storeListeners
};
